import { InitializerExecutor } from '@wajeez-web/core/types';
import { NavigationActions } from '@wajeez-web/stores/common';
import { RiCustomerService2Fill } from 'react-icons/ri';
import CustomerCarePage from './Pages/CustomerCarePage';
import ContactUsPage from './Pages/ContactUsPage';
import ReportProblemPage from './Pages/ReportReplomPage';
import WajeezCustomersPage from './Pages/WajeezCustomersPage';
import CustomerAnalyticsPage from './Pages/CustomerAnalyticsPage';
export const initializeCustomersRoutes: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateRoutes([
      {
        name: 'Customers',
        href: '/customers',
        per: ['75.1', '78.0', '18.0', '98.6'],
        icon: RiCustomerService2Fill,
        children: [
          {
            name: 'Customer Care',
            href: '/customer-care',
            per: ['18.22'],
          },
          {
            name: 'Report Problem',
            href: '/report-problem',
            per: ['75.6'],
          },

          {
            name: 'Contact Us',
            href: '/contact-us',
            per: ['86.1'],
          },
          {
            name: 'Customers',
            href: '/wajeez-customers',
            per: ['18.0'],
          },
        ],
      },
    ])
  );
};

export const initializeCustomersEndpoints: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateEndpoints([
      {
        type: 'container',
        endpoint: 'customer-care',
        per: ['75.1', '78.0', '18.0', '98.6'],
        crump: 'customer-care',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: CustomerCarePage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'contact-us',
        crump: 'contact-us',
        per: ['75.1', '78.0', '18.0', '98.6'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: ContactUsPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'report-problem',
        crump: 'report-problem',
        per: ['75.1', '78.0', '18.0', '98.6'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: ReportProblemPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'wajeez-customers',
        crump: 'wajeez-customers',
        per: ['75.1', '78.0', '18.0', '98.6'],
        children: [
          {
            type: 'endpoint',
            endpoint: ':id/analytics',
            component: CustomerAnalyticsPage,
            per: [],
          },
          {
            type: 'endpoint',
            endpoint: '',
            component: WajeezCustomersPage,
            per: [],
          },
        ],
      },
    ])
  );
};
